<template>
  <Layout>
    <PageHeader
      :items="items"
    />
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Listado Variables</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'variables' }"
          >
            Crear
            <b-icon
              class="icon-plus"
              icon="plus-circle-fill"
            ></b-icon>
          </router-link>
        </span>
      </div>
      <div class="card-app">
        <b-overlay
          :show="isSaving"
          blur="5px"
          :opacity="1"
          variant="transparent"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
        >
          <div class="row">
            <div class="col-md-12 p-0 mr-0 ml-0">
              <BaseDatatable
                ref="table"
                :drfprovider="getVariablesData"
                :tableheaders="fields"
                :perpage="50"
                fixed="True"
              >
                <template #head(actions)>
                  <span class="title-actions d-flex justify-content-center d-flex justify-content-center">Acciones</span>
                  <div class="d-flex content-actions">
                    <span>Editar</span>
                    <span>Eliminar</span>
                  </div>
                </template>
                <template v-slot:cell(label)="row">{{ row.value }}</template>
                <template v-slot:cell(dimension_name)="row">{{
                  row.value
                }}</template>
                <template v-slot:cell(type_name)="row">
                  <span class="h5"> </span>
                  {{ row.value }}
                </template>
                <template v-slot:cell(classification_name)="row"
                  >{{ row.value }}
                  <small class="text-danger" v-show="row.item.is_index"
                    >(Primaria)</small
                  ></template
                >
                <template v-slot:cell(state_name)="row"
                  ><span
                    :class="
                      row.item.state === 'A' ? 'text-success' : 'text-danger'
                    "
                    >{{ row.value }}</span
                  ></template
                >
                <template v-slot:cell(meta__modified_at)="row">{{
                  row.item.meta.modified_at
                }}</template>
                <template v-slot:cell(actions)="row">
                  <b-button-group size="xs" class="d-flex">
                    <b-button
                      :id="`update-btn-${row.index}`"
                      variant="btn-link btn-hover text-info btn-transparent"
                      size="xs"
                      @click.prevent="
                        $router.push({
                          name: 'variable',
                          params: { variableId: row.item.id },
                        })
                      "
                    >
                      <b-icon-pencil></b-icon-pencil>
                    </b-button>
                    <b-button
                      :id="`delete-btn-${row.index}`"
                      v-if="!row.item.is_index"
                      variant="btn-link text-danger btn-transparent"
                      size="xs"
                      @click.prevent="deleteVariablesData(row.item.id)"
                    >
                      <b-icon-trash></b-icon-trash>
                    </b-button>
                    <b-button
                      v-else
                      variant="btn-link text-danger btn-transparent"
                      size="xs"
                    />
                  </b-button-group>
                </template>
              </BaseDatatable>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
// import { formMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import { variablesMethods } from '@state/helpers'

export default {
  page: {
    title: 'Listado de Variables',
  },
  components: { Layout, PageHeader, BaseDatatable },
  data() {
    return {
      isSaving: false,
      eliminarVariable: false,
      items: [
        { text: '/', path: '/home', to: { name: 'home' } },
        { text: 'Listado de Variables', active: true },
      ],
      fields: [
        // { key: 'order', label: 'Orden', sortable: true },
        { key: 'label', label: 'Pregunta / Etiqueta', sortable: true },
        { key: 'dimension_name', label: 'Dimensión', sortable: true },
        { key: 'type_name', label: 'Tipo Variable', sortable: true },
        { key: 'classification_name', label: 'Clasificación', sortable: true },
        { key: 'state_name', label: 'Estado', sortable: true },
        {
          key: 'meta__modified_at',
          label: 'Fecha Modificación',
          sortable: true,
        },
        { key: 'actions', label: 'Acciones' },
      ],
      extraButtons: [
        {
          variant: 'info',
          title: 'Crear Nueva Variable',
          label: 'Crear',
          to: { name: 'variables' },
          icon: 'plus-circle-fill',
        },
      ],
      records: [],
    }
  },

  methods: {
    ...variablesMethods,

    deleteVariablesData(id) {
      let validate = 'True'
      const promise = this.deleteVariable({ id, validate })
      return promise
        .then((data) => {
          let title = ''
          let html = ''
          let typeSwall = ''
          let accion = ''
          if (data.Action == 'Delete') {
            accion = 'Sí, Eliminar'
            title = 'Eliminar Variable #' + id
            html =
              data.Message +
              '</br><span class="confirmDes">¿Confirma que deseas eliminar la variable #' +
              id +
              '?</span>'
            typeSwall = 'danger'
          } else {
            accion = 'Sí, Desactivar'
            title = 'Deshabilitar Variable #' + id
            html =
              data.Message +
              '</br><span class="confirmDes">¿Confirma que deseas deshabilitar la variable #' +
              id +
              '?</span>'
            typeSwall = 'warning'
          }
          this.$swal({
            title,
            html,
            buttons: { cancel: true, confirm: true },
            confirmButtonText: accion,
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            showCloseButton: true,
            width: '660px',
            position: 'top',
            customClass: {
              title: 'text-' + typeSwall,
              confirmButton: 'btn btn-primary rounded-pill order-2',
              cancelButton: 'btn bg-white text-dark rounded-pill order-1',
            },
            showClass: {
              backdrop: 'swal2-backdrop-show swal2-backdrop-' + typeSwall,
            },
          }).then((isconfirm) => {
            this.isSaving = true
            if (isconfirm.value == true) {
              validate = 'False'
              const promise = this.deleteVariable({ id, validate })
              return promise
                .then((data) => {
                  this.$refs.table.refresh()
                  this.isSaving = false
                  this.$generate_noty(
                    'success',
                    `Acción ejecutada correctamente`,
                    28000
                  )
                })
                .catch((error) => {
                  this.isSaving = false
                  this.$generate_noty(
                    'error',
                    'Se presentó un error con el servidor por favor valida más tarde'
                  )
                  console.log(
                    'Se presento un error en la carga de las variables.',
                    error
                  )
                })
            } else {
              this.isSaving = false
            }
          })
        })
        .catch((error) => {
          this.isSaving = false
          this.$generate_noty(
            'error',
            'Se presentó un error con el servidor por favor valida más tarde'
          )
          console.log(
            'Se presento un error en la carga de las variables.',
            error
          )
        })
    },
    getVariablesData(ctx) {
      const promise = this.getVariables(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las variables.',
            error
          )
        })
    },
  },
}
</script>

<style lang="scss">
.table-container {
  width: 100%;
}

.swal2-popup {
  width: 662px;
  height: 209px;
}
.inforAlert {
  color: blue;
}
.inforAlertEliminate {
  color: #ad0808;
  font-size: 22px;
}
.inforHtml {
  font-weight: bold;
}
.inforHtmlDes {
  font-weight: 100;
}
.confirmDes {
  font-weight: bold;
}
.subNoteVariable {
  font-weight: 50;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
</style>
